import React from 'react'

export default class ConnectDemolition extends React.Component
{

    render()
    {
        return(
            
            <div className="connect mb-5">
                <h3>Connect With Hometown</h3>
                <div className="card">
                    <a href="https://www.facebook.com/HometownDemolitionContractors/" role="button" aria-label="facebbok" rel="noreferrer" target="_blank" className="facebook"></a>
                    <a href="https://twitter.com/HometownDemo" role="button" aria-label="twitter" rel="noreferrer" target="_blank" className="twitter"></a>
                    <a href="https://www.pinterest.com/hometowndiytips/" role="button" aria-label="pinterest" rel="noreferrer"  target="_blank" className="pinterest"></a>          
                    <a href="https://www.youtube.com/channel/UCVlHIvd1yvOU1fT7d7YdZXg/videos" role="button" aria-label="youtube" rel="noreferrer" target="_blank" className="youtube"></a>
                </div>
            </div>
        
        )
    }
    
}
